import {
  type UdpTrackingImpressionOrigin,
  type UdpTrackingImpressionOriginData,
  type UdpTrackingProduct,
  type UdpTrackingProductImpression,
} from './model/udpTrackingTypes'
import { udpTrackingCreateImpressionId } from './udpTrackingCreateImpressionId'

export const udpTrackingBuildProductImpression = ({
  impressionOrigin,
  impressionOriginData,
  product,
  quantity,
}: {
  impressionOrigin: UdpTrackingImpressionOrigin | null
  impressionOriginData: UdpTrackingImpressionOriginData | null
  product: UdpTrackingProduct
  quantity?: number
}): UdpTrackingProductImpression => ({
  impression_id:
    impressionOrigin === null ? null : udpTrackingCreateImpressionId(),
  impression_origin: impressionOrigin,
  impression_origin_data: impressionOriginData,
  product,
  quantity,
})
